import { render, staticRenderFns } from "./SearchOPDForGeneral.vue?vue&type=template&id=cedb899c"
import script from "./SearchOPDForGeneral.vue?vue&type=script&lang=js"
export * from "./SearchOPDForGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports